import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';

const SettingsContext = createContext();

export const useSettings = () => {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error('useSettings must be used within SettingsProvider');
  }
  return context;
};

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({
    companyName: 'Paanap',
    tagline: '',
    logoUrl: null,
    primaryColor: '#64A8ED',
    secondaryColor: '#C51668',
    accentColor: '#FB9637',
    headerBackgroundColor: '#64A8ED',
    backgroundColor: '#F5F5F5',
    primaryFont: 'Poppins',
    headingFont: 'Inter',
    showLogoInHeader: true,
    showCompanyName: true
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api/v1';
      const response = await axios.get(`${API_BASE_URL}/settings`);
      
      // ✅ FIX: Properly extract settings from nested response
      const settingsData = response.data.data?.settings || response.data.data || response.data.settings;
      
      console.log('Settings loaded:', settingsData); // Debug log
      
      if (settingsData) {
        setSettings(settingsData);
      }
    } catch (error) {
      console.error('Error fetching settings:', error);
      // Keep default settings on error
    } finally {
      setLoading(false);
    }
  };

  const refreshSettings = async () => {
    await fetchSettings();
  };

  return (
    <SettingsContext.Provider value={{ settings, loading, refreshSettings }}>
      {children}
    </SettingsContext.Provider>
  );
};